import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { CostCentersStructureDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CostCentersNestedList } from 'modules/cost_centers/components/CostCenterNestedList'
import { EmptyCostCentersStructure } from 'modules/cost_centers/components/CostCentersStructure/EmptyState'
import { hasCostCenterConfigurationPending } from 'modules/cost_centers/lib/costCenterHelpers'
import { CostCenterConfigurations } from 'modules/cost_centers/lib/types'

import { CostCenterConfiguration } from './Configuration'

const CostCentersStructure = ({
  canManageCostCenters,
  configurations,
}: {
  canManageCostCenters: boolean
  configurations: CostCenterConfigurations
}) => {
  const [configure, setConfigure] = useState<boolean>(false)

  const { data: structureData, loading: structureLoading } = useQuery(CostCentersStructureDocument)

  const hasConfigurationPending = useUnsafeMemo(() => {
    return hasCostCenterConfigurationPending(configurations)
  }, [configurations])

  if (structureLoading) {
    return (
      <Box flexGrow justifyContent="center" alignItems="center">
        <Loading />
      </Box>
    )
  }

  if (configure) {
    return <CostCenterConfiguration data={structureData} cancel={() => setConfigure(false)} />
  }

  if (configurations.length === 0 || hasConfigurationPending) {
    return (
      <EmptyCostCentersStructure
        hasConfigurationPending={hasConfigurationPending}
        canManageCostCenters={canManageCostCenters}
        hasWorkplaces={!!structureData?.locations?.locations?.length}
        hasJobCatalog={!!structureData?.jobCatalog?.treesConnection?.nodes?.length}
        startConfiguration={() => setConfigure(true)}
      />
    )
  }

  return (
    <CostCentersNestedList
      canManageCostCenters={canManageCostCenters}
      configurations={configurations}
    />
  )
}

export { CostCentersStructure }
